"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AIAgent = function AIAgent(_ref) {
  var email = _ref.email,
    token = _ref.token;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var compareSectionRefs = (0, _react.useRef)([]);
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    mainData = _useState4[0],
    setMainData = _useState4[1];
  var _useState5 = (0, _react.useState)(['Product Share', "Like Product", "Comment On Share", "View Product"]),
    _useState6 = _slicedToArray(_useState5, 2),
    types = _useState6[0],
    setTypes = _useState6[1];
  var _useState7 = (0, _react.useState)('View Product'),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedType = _useState8[0],
    setSelectedType = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    pageNo = _useState10[0],
    setPageNo = _useState10[1];
  var _useState11 = (0, _react.useState)(20),
    _useState12 = _slicedToArray(_useState11, 2),
    count = _useState12[0],
    setCount = _useState12[1];
  var recommended_products_url = 'https://api.jesssu.com/api/getairecommendedproducts';
  var comparison_product_url = 'https://api.jesssu.com/api/getproductcomparision';
  (0, _react.useEffect)(function () {
    getRecommendedProduct(selectedType);
  }, []);
  var groupByPrimaryValue = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(products) {
      var grouped, recommendedProductArrays, _i, _Object$entries, _Object$entries$_i, Primary, items, i, chunk;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            grouped = products.reduce(function (acc, product) {
              if (!acc[product.Primary]) acc[product.Primary] = [];
              acc[product.Primary].push(product);
              return acc;
            }, {});
            recommendedProductArrays = [];
            for (_i = 0, _Object$entries = Object.entries(grouped); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), Primary = _Object$entries$_i[0], items = _Object$entries$_i[1];
              for (i = 0; i < items.length; i += 5) {
                chunk = items.slice(i, i + 5);
                recommendedProductArrays.push({
                  Primary: Primary,
                  recommendedProducts: chunk,
                  primaryProduct: chunk[0]
                });
              }
            }
            return _context.abrupt("return", recommendedProductArrays);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function groupByPrimaryValue(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getRecommendedProduct = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dataType) {
      var payload;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            payload = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                'email': email,
                'token': token,
                'pageno': pageNo,
                'count': count,
                'type': dataType
              })
            };
            fetch(recommended_products_url, payload).then(function (response) {
              return response.json();
            }).then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
                var finalProductList;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!data) {
                        _context2.next = 6;
                        break;
                      }
                      _context2.next = 3;
                      return groupByPrimaryValue(data);
                    case 3:
                      finalProductList = _context2.sent;
                      finalProductList.map(function (i) {
                        i.recommendedBox = false;
                        i.comparisionBox = false;
                        i.compareProducts = [];
                        i.comparisionData = null;
                        i.bestProduct = null;
                      });
                      setMainData(finalProductList);
                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }())["catch"](function (error) {
              console.error('API request error:', error);
            });
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getRecommendedProduct(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getRecommendedProductComparision = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(index) {
      var payload;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            payload = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                'products': mainData[index].compareProducts,
                'token': token
              })
            };
            fetch(comparison_product_url, payload).then(function (response) {
              return response.json();
            }).then(function (data) {
              if (data) {
                var SKU = extractSKU(data.response);
                var bestProduct = findProductBySKU(mainData[index], SKU);
                setMainData(function (prevItems) {
                  return prevItems.map(function (item, i) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      comparisionData: i === index ? data.response.replace(/The best product based on the provided information is:\s*[:\s]*[\{\[]?\w+[\}\]]?\.?/, '').trim() : null,
                      bestProduct: i === index ? bestProduct : null
                    });
                  });
                });
              }
              replace(/The best product based on the provided information is:\s*[:\s]*[\{\[]?\w+[\}\]]?\.?/, '').trim();
            })["catch"](function (error) {
              console.error('API request error:', error);
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getRecommendedProductComparision(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleChatbotClick = function handleChatbotClick() {
    setIsOpen(!isOpen);
  };
  var handleCloseClick = function handleCloseClick() {
    setIsOpen(false);
  };
  var extractSKU = function extractSKU(responseText) {
    var match = responseText.match(/The best product based on the provided information is:\s*[:\s]*[\{\[]?(\w+)[\}\]]?\b/);
    // const skuPattern = /SKU\s([A-Z0-9]+)/;
    // const match = responseText.match(skuPattern);
    return match ? match[1] : null;
  };
  var findProductBySKU = function findProductBySKU(data, skuToFind) {
    if (data.primaryProduct.SKU === skuToFind) {
      return data.primaryProduct;
    }
    var matchedProduct = data.recommendedProducts.find(function (product) {
      return product.SKU === skuToFind;
    });
    return matchedProduct || null;
  };
  var handleCompareClick = function handleCompareClick(index) {
    setMainData(function (prevItems) {
      return prevItems.map(function (item, i) {
        return _objectSpread(_objectSpread({}, item), {}, {
          recommendedBox: i === index ? !item.recommendedBox : false
        });
      });
    });
  };
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isExpanded = _useState14[0],
    setIsExpanded = _useState14[1];
  var toggleExpansion = function toggleExpansion() {
    setIsExpanded(!isExpanded);
  };
  var handleCheckboxChange = function handleCheckboxChange(index, compData, isChecked) {
    setMainData(function (prevItems) {
      var updatedItems = _toConsumableArray(prevItems);
      var updatedCompareProducts = _toConsumableArray(updatedItems[index].compareProducts);
      if (isChecked) {
        updatedCompareProducts.push(compData);
      } else {
        var productIndex = updatedCompareProducts.findIndex(function (product) {
          return product.id === compData.id;
        });
        if (productIndex > -1) {
          updatedCompareProducts.splice(productIndex, 1);
        }
      }
      updatedItems[index] = _objectSpread(_objectSpread({}, updatedItems[index]), {}, {
        compareProducts: updatedCompareProducts
      });
      return updatedItems;
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflowY: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'fixed',
      bottom: '16px',
      right: '16px'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleChatbotClick,
    style: {
      backgroundColor: '#F59E0B',
      color: 'white',
      padding: '12px',
      borderRadius: '50%',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      outline: 'none',
      transition: 'background-color 0.3s'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "/chatbot.svg",
    alt: "Chatbot",
    style: {
      width: '24px',
      height: '24px'
    }
  }))), isOpen && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'fixed',
      bottom: '64px',
      right: '16px',
      backgroundColor: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      borderRadius: '8px',
      width: '90%',
      maxWidth: '384px',
      border: '1px solid #E5E7EB',
      zIndex: 50,
      maxHeight: '80vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: '#F59E0B',
      color: 'white',
      padding: '12px',
      borderRadius: '8px 8px 0 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "/chatbot.svg",
    alt: "Chatbot",
    style: {
      width: '24px',
      height: '24px'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      fontWeight: '600'
    }
  }, "JesssuAgent"), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: 'black',
      fontSize: '12px'
    }
  }, "Online"))), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleCloseClick,
    style: {
      color: 'white',
      outline: 'none',
      background: 'none',
      border: 'none',
      fontSize: '24px'
    }
  }, "\xD7")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '16px',
      flexGrow: 1,
      overflowY: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "/chatbot1.svg",
    alt: "Recommend",
    style: {
      width: '40px',
      height: '40px'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '16px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }
  }, mainData.length !== 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mainData === null || mainData === void 0 ? void 0 : mainData.map(function (data, index) {
    var _data$recommendedProd, _data$primaryProduct, _data$primaryProduct2, _data$primaryProduct3, _data$primaryProduct4, _data$compareProducts2, _data$recommendedProd2, _data$bestProduct, _data$bestProduct2;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (data === null || data === void 0 || (_data$recommendedProd = data.recommendedProducts) === null || _data$recommendedProd === void 0 ? void 0 : _data$recommendedProd.length) > 1 && /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      style: {
        backgroundColor: '#F3F4F6',
        padding: '16px',
        borderRadius: '8px',
        width: '100%',
        height: 'auto',
        gap: '12px',
        display: 'flex',
        flexDirection: 'column'
      },
      ref: function ref(el) {
        return compareSectionRefs.current[index] = el;
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        gap: '12px'
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: data === null || data === void 0 || (_data$primaryProduct = data.primaryProduct) === null || _data$primaryProduct === void 0 ? void 0 : _data$primaryProduct.ProductImage,
      alt: data === null || data === void 0 || (_data$primaryProduct2 = data.primaryProduct) === null || _data$primaryProduct2 === void 0 ? void 0 : _data$primaryProduct2.SKU,
      style: {
        width: '100%',
        maxWidth: '80px',
        height: '80px',
        objectFit: 'cover',
        borderRadius: '8px',
        flexShrink: 0
      }
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '8px',
        color: '#4B5563'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        textDecoration: 'line-through',
        color: '#9CA3AF'
      }
    }, data === null || data === void 0 || (_data$primaryProduct3 = data.primaryProduct) === null || _data$primaryProduct3 === void 0 ? void 0 : _data$primaryProduct3.RetailPrice), " ", /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, data === null || data === void 0 || (_data$primaryProduct4 = data.primaryProduct) === null || _data$primaryProduct4 === void 0 ? void 0 : _data$primaryProduct4.SalePrice)), /*#__PURE__*/_react["default"].createElement("button", {
      style: {
        backgroundColor: '#F59E0B',
        color: 'white',
        width: '100%',
        padding: '8px',
        marginTop: '8px',
        borderRadius: '8px',
        fontSize: '12px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        whiteSpace: 'nowrap'
      },
      onClick: function onClick() {
        var _data$compareProducts;
        if ((data === null || data === void 0 ? void 0 : data.recommendedBox) === true && (data === null || data === void 0 || (_data$compareProducts = data.compareProducts) === null || _data$compareProducts === void 0 ? void 0 : _data$compareProducts.length) > 1) {
          getRecommendedProductComparision(index);
        } else {
          handleCompareClick(index);
        }
      }
    }, (data === null || data === void 0 ? void 0 : data.recommendedBox) === true && (data === null || data === void 0 || (_data$compareProducts2 = data.compareProducts) === null || _data$compareProducts2 === void 0 ? void 0 : _data$compareProducts2.length) > 1 ? 'Compare' : 'Compare with similar product'))), (data === null || data === void 0 ? void 0 : data.recommendedBox) === true && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '12px'
      }
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        fontSize: '14px'
      }
    }, "Please select the products you want to compare"), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px'
      }
    }, data === null || data === void 0 || (_data$recommendedProd2 = data.recommendedProducts) === null || _data$recommendedProd2 === void 0 ? void 0 : _data$recommendedProd2.map(function (compData, compIndex) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: compIndex,
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: compData === null || compData === void 0 ? void 0 : compData.MainImage,
        alt: compData === null || compData === void 0 ? void 0 : compData.SKU,
        style: {
          width: '100%',
          height: '80px',
          objectFit: 'cover',
          borderRadius: '8px',
          marginBottom: '8px'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          padding: '0 4px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          textDecoration: 'line-through',
          color: '#9CA3AF',
          fontSize: '12px'
        }
      }, compData === null || compData === void 0 ? void 0 : compData.RetailPrice), " ", /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold',
          fontSize: '14px',
          marginLeft: '4px'
        }
      }, compData === null || compData === void 0 ? void 0 : compData.SalePrice)), /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        style: {
          marginTop: '4px',
          marginLeft: '8px'
        },
        onChange: function onChange(e) {
          return handleCheckboxChange(index, compData, e.target.checked);
        }
      })));
    }))), (data === null || data === void 0 ? void 0 : data.comparisionData) !== null && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '16px',
        border: '1px solid #D1D5DB',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }
    }, (data === null || data === void 0 ? void 0 : data.bestProduct) !== null && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: data === null || data === void 0 || (_data$bestProduct = data.bestProduct) === null || _data$bestProduct === void 0 ? void 0 : _data$bestProduct.ProductImage,
      alt: "Comparison Image",
      style: {
        width: '80px',
        height: '80px',
        objectFit: 'cover',
        borderRadius: '8px'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        textDecoration: 'line-through',
        color: '#9CA3AF',
        fontSize: '12px'
      }
    }, data === null || data === void 0 || (_data$bestProduct2 = data.bestProduct) === null || _data$bestProduct2 === void 0 ? void 0 : _data$bestProduct2.SalePrice), " ", /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontWeight: 'bold',
        fontSize: '14px'
      }
    }, "699"), /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        var _data$bestProduct3;
        return window.open("".concat(data === null || data === void 0 || (_data$bestProduct3 = data.bestProduct) === null || _data$bestProduct3 === void 0 || (_data$bestProduct3 = _data$bestProduct3.channels[0]) === null || _data$bestProduct3 === void 0 ? void 0 : _data$bestProduct3.url), '_blank');
      },
      style: {
        backgroundColor: '#F59E0B',
        color: 'white',
        width: '100%',
        padding: '8px',
        marginTop: '8px',
        borderRadius: '8px',
        fontSize: '16px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.3s'
      }
    }, "Buy Now")))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: '14px',
        marginTop: '8px'
      }
    }, /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        marginBottom: '8px',
        color: '#6B7280'
      }
    }, "Here's why:"), /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        color: '#6B7280'
      }
    }, (data === null || data === void 0 ? void 0 : data.comparisionData).slice(0, 100), isExpanded && /*#__PURE__*/_react["default"].createElement("span", null, ' ', (data === null || data === void 0 ? void 0 : data.comparisionData).slice(100)), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: '#3B82F6',
        cursor: 'pointer'
      },
      onClick: toggleExpansion
    }, isExpanded ? ' Show less' : ' Read more...'))))))));
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "display": "flex"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "flex": 1,
      "textAlign": "center",
      "padding": "30px"
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      "height": "125px",
      "width": "125px"
    },
    src: selectedType === "Product Share" ? "/share.png" : selectedType === "Like Product" ? "/top.png" : selectedType === "Comment On Share" ? "/point-out.png" : selectedType === "View Product" ? "/find.png" : "",
    alt: "Recommended Type Image"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "flex": 1,
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "center",
      "alignItems": "center",
      "padding": "20px"
    }
  }, /*#__PURE__*/_react["default"].createElement("button", null, selectedType === "Product Share" ? "Share your favorite products with your friends to get product recommendation" : selectedType === "Like Product" ? "Like your favorite product posts to get product recommendation" : selectedType === "Comment On Share" ? "Comment on the posts to get product recommendation" : "Checkout more products from Jesssu to get our recommmendation for you.")))))))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: 'white',
      padding: '16px',
      flexShrink: 0
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '8px'
    }
  }, types.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: index,
      style: {
        padding: '8px',
        borderRadius: '8px',
        backgroundColor: selectedType === data ? '#F59E0B' : '#E5E7EB',
        color: selectedType === data ? 'white' : 'black',
        cursor: 'pointer'
      },
      onClick: function onClick() {
        setSelectedType(data);
        getRecommendedProduct(data);
      }
    }, data);
  }))))));
};
var _default = exports["default"] = AIAgent;